import FormInput from '../FormInput/FormInput';
import FormGroup from '../FormGroup/FormGroup';
import FormSection from '../FormSection/FormSection';
import { JSONObject, ReferenceControl } from '../../../../../types/types';
import { Dispatch } from 'react';
import { useRequestDataContext } from '../../../../../hooks/context/useRequestDataContext';

export interface FormresolverProps {
  formItem: any;
  /** When false, fields inside a section tab are forced read-only regardless of item-level `editable`. */
  sectionEditable?: boolean;
  referenceDatasets: any;
  setReferenceDatasets: Dispatch<any>;
  openFullscreenReference: (
    name: string,
    datasetId: string,
    control: ReferenceControl,
    value: string,
    label: string,
    // resolvedFilter forwarded from ReferenceInput's click-time JSONata pass.
    // null sentinel = resolved to nothing (strip raw filter).
    resolvedFilter?: Record<string, any> | null
  ) => void;
}

const FormItemResolver = ({
  formItem,
  sectionEditable = true,
  openFullscreenReference,
  referenceDatasets,
  setReferenceDatasets,
}: FormresolverProps) => {
  const requestData = useRequestDataContext();
  const resolveData = (requestData ?? {}) as JSONObject;

  const isGroup = formItem.type === 'group';
  const isSectionGroup = Array.isArray(formItem);

  if (isSectionGroup) {
    return (
      <FormSection
        sectionItems={formItem}
        referenceDatasets={referenceDatasets}
        setReferenceDatasets={setReferenceDatasets}
        openFullscreenReference={openFullscreenReference}
      />
    );
  }

  if (isGroup) {
    return (
      <FormGroup
        caption={formItem.caption}
        visible={formItem.visible}
        allowVisible={formItem.allowVisible}
        items={formItem.items}
        resolveData={resolveData}
      >
        {formItem.items.map((subItem, index) => (
          <FormInput
            {...subItem}
            key={`${subItem.name}_${index}`}
            editable={sectionEditable === false ? false : subItem.editable}
            resolveData={resolveData}
            referenceDatasets={referenceDatasets}
            setReferenceDatasets={setReferenceDatasets}
            openFullscreenReference={openFullscreenReference}
          />
        ))}
      </FormGroup>
    );
  }

  return (
    <FormInput
      {...formItem}
      editable={sectionEditable === false ? false : formItem.editable}
      resolveData={resolveData}
      openFullscreenReference={openFullscreenReference}
      referenceDatasets={referenceDatasets}
      setReferenceDatasets={setReferenceDatasets}
    />
  );
};

export default FormItemResolver;
